import { useEffect } from "react"
import Flex from "../../components/Flex"
import Screen from "./components/Screen"
import { spacing } from "./styles"

import "./Products.scss"
import Button from "./components/Button"
import { useLocation, useNavigate } from "react-router-dom"
import datasource from "../../datasource"
import MobileIcon from "../../components/MobileIcon"
import useNav from "../../components/useNav"

interface ProductCta {
    label: string
    type: "contact" | "link" | "page"
    link: string
}

interface Product {
    slug: string
    title: string
    tagline: string
    description: string
    capabilities: string[]
    mobileIcon: React.JSX.Element
    cta: ProductCta
}

const {
    pageTitle,
    pageSubTitle,
    items,
    welcomeTitle,
    welcomeSubTitle
} = datasource.products

export default () => {

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.hash) {
            const slug = location.hash.replace("#", "")
            setTimeout(() => {
                document.getElementById(`product-${slug}`)?.scrollIntoView({ behavior: "smooth", block: "start" })
            }, 100)
        }
    }, [location.hash])

    const goToCareer = () => {
        navigate("/careers")
        document.scrollingElement?.scrollTo({ top: 0, behavior: "smooth" })
    }

    return (
        <div className="mb-products">
            <Screen className="mb-products__title-screen">
                <Flex vertical gap={spacing("xl")}>
                    <div className="mb-products__title">{pageTitle}</div>
                    <div className="mb-products__subTitle">{pageSubTitle}</div>
                </Flex>
            </Screen>
            <div className="mb-products__grid-box">
                <Flex vertical gap={spacing("3xl")}>
                    {(items as Product[]).map(it => <ProductCard key={it.slug} product={it}></ProductCard>)}
                </Flex>
            </div>
            <Screen className="mb-products__welcome-screen">
                <Flex vertical className="mb-products__welcome" gap={spacing("4xl")}>
                    <Flex vertical gap={10} align="center">
                        <div className="mb-products__welcome__title">{welcomeTitle}</div>
                        <div className="mb-products__welcome__subTitle">{welcomeSubTitle}</div>
                    </Flex>
                    <Button className="mb-products__weclome__btn" onClick={goToCareer}>
                        <Flex justify="center">New Openings</Flex>
                    </Button>
                </Flex>
            </Screen>
        </div>
    )
}

const ProductCard = (props: { product: Product }) => {
    const navigate = useNavigate()
    const { nav } = useNav()

    const doCta = () => {
        const { type, link } = props.product.cta
        if (type === "contact") {
            // deliberately not scrolling to top: land on home, then on the contact form
            navigate(link)
            setTimeout(() => {
                document.scrollingElement?.scrollTo({ top: window.innerHeight, behavior: "smooth" })
            }, 100)
        } else if (type === "page") {
            // useNav navigates and smooth-scrolls to top, same as the inline form
            nav(link)
        } else {
            window.open(link, "_blank", "noopener,noreferrer")
        }
    }

    return (
        <Flex vertical id={`product-${props.product.slug}`} className="mb-product-card" gap={spacing("lg")}>
            <Flex align="center" justify="center" className="mb-product-card__icon-box">
                {props.product.mobileIcon}
            </Flex>
            <Flex vertical gap={spacing("xs")}>
                <div className="mb-product-card__title">{props.product.title}</div>
                <div className="mb-product-card__tagline">{props.product.tagline}</div>
            </Flex>
            <div className="mb-product-card__description">{props.product.description}</div>
            <Flex vertical gap={spacing("md")} className="mb-product-card__capabilities">
                {props.product.capabilities.map(capability => (
                    <div key={capability} className="mb-product-card__capability">{capability}</div>
                ))}
            </Flex>
            <Flex className="mb-product-card__cta">
                <Button onClick={doCta}>
                    <Flex gap={spacing("md")} reposive={false} align="center">
                        {props.product.cta.label}
                        <MobileIcon.ArrowUp width={20} height={20}></MobileIcon.ArrowUp>
                    </Flex>
                </Button>
            </Flex>
        </Flex>
    )
}
